import { Injectable, inject } from '@angular/core';
import { BaseCommandRepository } from '@okcargo-apps/shared-infrastructure';
import { UploadCompanyDocumentCommand, UploadCompanyDocumentCommandHandler } from '@okcargo/command-processor';

@Injectable({ providedIn: 'root' })
export class DocumentUploaderCommandService {
  private readonly commandRepository = inject(BaseCommandRepository);

  private readonly uploadCompanyDocumentCommandHandler: UploadCompanyDocumentCommandHandler;

  constructor() {
    const commandRepository = this.commandRepository;

    this.uploadCompanyDocumentCommandHandler = new UploadCompanyDocumentCommandHandler(commandRepository);
  }

  uploadCompanyDocument(command: UploadCompanyDocumentCommand): Promise<void> {
    return this.uploadCompanyDocumentCommandHandler.handle(command);
  }
}
